import React, {useEffect, useState} from 'react';
import Pane from "../../Components/Pane";
import Text from "../../Components/Text";
import PrimaryTitle from "../../Components/PrimaryTitle";
import PageLoadingPanel from "../../Components/PageLoadingPanel";
import Spacer from "../../Components/Spacer";
import SecondaryTitle from "../../Components/SecondaryTitle";
import ApplicationInformation from "../../Components/ReviewApplication/ApplicationInformation";
import ClientDetails from "../../Components/ReviewApplication/ClientDetails";
import IsaDetails from "../../Components/ReviewApplication/IsaDetails";
import BankingDetails from "../../Components/ReviewApplication/BankingDetails";
import TaxDetails from "../../Components/ReviewApplication/TaxDetails";

const CongratulationsPage = (props) => {
    const PAGE_TITLE = 'Your application has been submitted below is a summary';

    const [clientDetails, setClientDetails] = useState([
        {
            'title':                                         '',
            'first_name':                                    '',
            'last_name':                                     '',
            'email':                                         '',
            'phone_prefix':                                  '',
            'phone_number':                                  '',
            'dual_nationality':                              '',
            'primary_nationality':                           '',
            'secondary_nationality':                         '',
            'date_of_birth':                                 '',
            'national_insurance_number':                     '',
            'occupation':                                    '',
            'residential_address_line_1':                    '',
            'residential_address_line_2':                    '',
            'residential_town_city':                         '',
            'residential_state_county':                      '',
            'residential_postcode':                          '',
            'residential_country':                           '',
            'residential_occupied_since_year':               '',
            'residential_occupied_since_month':              '',
            'permanent_address_is_correspondence_address':   '',
            'correspondence_address_line_1':                 '',
            'correspondence_address_line_2':                 '',
            'correspondence_town_city':                      '',
            'correspondence_state_county':                   '',
            'correspondence_postcode':                       '',
            'correspondence_country':                        '',
            'correspondence_occupied_since_year':            '',
            'correspondence_occupied_since_month':           '',
        },
    ]);
    const [bankingDetails, setBankingDetails] = useState({
        'bank_name':             '',
        'account_holder_name':   '',
        'sort_code':             '',
        'account_number':        '',
        'source_of_funds':       '',
    });
    const [isaDetails, setIsaDetails] = useState({
        'first_isa_option_selected':    '',
        'opening_isa_detail':           {
            'isa_type':     '',
            'isa_amount':   '',
        },
        'transferring_isa_detail':      {
            'isa_type':                                      '',
            'isa_amount':                                    '',
            'current_isa_reference_number':                  '',
            'current_isa_manager':                           '',
            'current_isa_manager_address':                   '',
            'current_isa_transfer_date_requested':           '',
            'current_isa_first_subscription_current_year':   '',
        }
    });
    const [taxDetails, setTaxDetails] = useState({
        'all_individuals_are_uk_resident':  '',
    });
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        load();
    }, []);

    const load = () => {
        axios.get(route('web-api.session.congratulations.get', {session: window.session}).toString())
            .then((response) => {
                if (!!response && !!response.data) {
                    setClientDetails(response.data.client_details);
                    setBankingDetails(response.data.banking_details);
                    setIsaDetails(response.data.isa_details);
                    setTaxDetails(response.data.tax_details);
                }
            })
            .catch((error) => {
                console.log(error);
            }).finally(() => {
            setLoaded(true);
        });
    }

    if (!loaded) {
        return (
            <PageLoadingPanel
                pageTitle={PAGE_TITLE}
            />
        )
    }

    return (
        <Pane>
            <PrimaryTitle>{PAGE_TITLE}</PrimaryTitle>
            <Spacer/>
            <ApplicationInformation data={clientDetails}/>
            <Spacer/>
            <SecondaryTitle>Client / account holder details</SecondaryTitle>
            {clientDetails.map((client, index) => (
                <div key={index}>
                    {/*{index === 1 ? (*/}
                    {/*    <Text style={{fontWeight: 'bold'}}>Client 2</Text>*/}
                    {/*) : (*/}
                    {/*    <Text style={{fontWeight: 'bold'}}>Client 1 (You)</Text>*/}
                    {/*)}*/}
                    <ClientDetails data={client}/>
                </div>
            ))}
            <Spacer/>
            <IsaDetails data={isaDetails}/>
            <Spacer/>
            <BankingDetails data={bankingDetails}/>
            <Spacer/>
            <TaxDetails data={taxDetails}/>
        </Pane>
    );
}

export default CongratulationsPage;
